import React, { Component } from "react";
import PropTypes from "prop-types";

import Slider from "rc-slider";

import { Toast } from "C4";

import "rc-slider/assets/index.css";

export default class TrainingSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answerFeedback: "",
      toastContent: null,
    };
  }

  render() {
    const {
      contentComplete,
      correctAnswer,
      correctAnswerText,
      disableHeader,
      disableToast,
      endNumber,
      error,
      incorrectAnswerText,
      question,
      startNumber,
      steps,
    } = this.props;

    const marks = {};
    const noSteps = steps.every((step) => +step === 0);
    console.log("noSteps", noSteps);
    console.log("steps", steps);
    if (noSteps) {
      steps.forEach((step, index) => {
        if (step !== null) {
          marks[Math.round(+endNumber / (steps.length - 1)) * index] =
            Math.round(+endNumber / (steps.length - 1)) * index;
        }
      });
    } else {
      steps.forEach((step, index) => {
        // Filter out null values
        if (step !== null) {
          marks[Math.round(+endNumber / (steps.length - 1)) * index] =
            steps[index];
        }
      });
    }

    const { answerFeedback, toastContent } = this.state;

    return (
      <div className="container__question">
        {!disableHeader && <div className="container__question--image" />}
        <div className="container__question--content trainingSlider">
          <h4 className="container__title">{question}</h4>
          <div className="slider__container">
            <Slider
              className={`questionSlider ${answerFeedback}`}
              min={+startNumber}
              max={+endNumber}
              step={null} // NOTE: Slider's step property needs to be null and cannot be left empty
              marks={marks || null}
              onAfterChange={(value) => {
                if (marks && +marks[value] === +correctAnswer) {
                  this.setState({
                    answerFeedback: "correct",
                    toastContent: {
                      content: correctAnswerText,
                      position: "bottom-center",
                    },
                  });
                  contentComplete();
                } else {
                  // this.setState({
                  //   answerFeedback: 'wrong',
                  //   toastContent: {
                  //     type: 'error',
                  //     content: incorrectAnswerText,
                  //     position: 'bottom-center',
                  //   },
                  // });
                  error(true);
                }
              }}
            />
          </div>
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => {
                this.setState({ toastContent: null });
              }}
              {...toastContent}
            />
          )}
          {error(false)}
        </div>
      </div>
    );
  }
}

TrainingSlider.propTypes = {
  contentComplete: PropTypes.func.isRequired,
  correctAnswer: PropTypes.string.isRequired,
  correctAnswerText: PropTypes.string,
  disableHeader: PropTypes.bool,
  disableToast: PropTypes.bool,
  endNumber: PropTypes.string.isRequired,
  error: PropTypes.func,
  incorrectAnswerText: PropTypes.string,
  question: PropTypes.string.isRequired,
  startNumber: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

TrainingSlider.defaultProps = {
  correctAnswerText: "",
  disableHeader: false,
  disableToast: false,
  error: () => {},
  incorrectAnswerText: "",
  startNumber: 0,
};
